import * as actions from '../constants';
import { SortOption } from '../../components/UI/SortControl';

export const setSortOption = (option: SortOption) => ({ type: actions.SET_SORT_OPTION, data: { option } });
export const setSortType = (type: 'asc' | 'desc') => ({ type: actions.SET_SORT_TYPE, data: { type } });